import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ccc-cca-route-proxy',
  templateUrl: './route-proxy.component.html',
  styleUrls: ['./route-proxy.component.scss']
})
export class RouteProxyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
